export default __webpack_public_path__ + "static/media/goback.8c592ca9.svg";